import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9wvd77syf: FaireProductEntity = {
  token: "p_g9wvd77syf",
  type: "product",
  name: "Scandinavian from Scratch",
  brandToken: "b_q68qsrd57c",
  brandName: "Penguin Random House LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/dc623a5fc89c158608d861df52986647b522eb7fca70dbd26021f67b6687c965.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e3a48e8de2606d1aa6d98a1975195d84e1c310e1c01134773411a8583884692.jpeg",
    "https://cdn.faire.com/fastly/21a60ae891618ee6a3bc0babdb147342cd0d14787015430c5f6d0ea212e59c98.jpeg",
    "https://cdn.faire.com/fastly/b0c9ba1f584c4089f28e687eb13aa86cb3f2ca0feec7f1fb519e7b8207421780.jpeg",
    "https://cdn.faire.com/fastly/fea54385848cc26846c064cdde7e461d7a7dcb459a06c332fa1883fc91bdb505.jpeg",
    "https://cdn.faire.com/fastly/d81e902343064bd49deaac3f50b32347f1cc0982576b7c56cce47411d21e720d.jpeg",
    "https://cdn.faire.com/fastly/3f54883b31ff2477590f4f61869e2cedc520741bbc61dd96fdd74e1ea7bf1d2f.jpeg",
    "https://cdn.faire.com/fastly/48886798e2874519305a78fc3a92951606de7046e0050832ad5a6de7703a4266.jpeg",
  ],
  priceDollars: 14.99,
  description:
    "Smørrebrød: a classic open-faced layered sandwich on rye bread.\nIn Scandinavia-comprised of Denmark, Norway, and Sweden-home baking provides a way to find comfort throughout the long, dark winters, drawing warmth from the oven and satisfaction from the meditative and nourishing act.\nThe summer before she attended the Culinary Institute of America, Nichole Accettola traveled to Denmark and fell in love with the people, the weather, and of course, the baking. After culinary school, she married a Danish journalist and lived in Copenhagen for fifteen years before returning to the United States to open her San Francisco-based cafe, Kantine, inspired by the pastries she'd enjoyed in Denmark. \nDuring her time in Copenhagen, Nichole combatted winter blues by baking with her Danish mother-in-law, learning how to churn out batches of scrumptious holiday cookies, and filling tins with homemade nougats and caramels.",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:47.663Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
